import { render, staticRenderFns } from "./SipTrunkDetailDrawer.vue?vue&type=template&id=20eec9c4&scoped=true"
import script from "./SipTrunkDetailDrawer.vue?vue&type=script&lang=js"
export * from "./SipTrunkDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./SipTrunkDetailDrawer.vue?vue&type=style&index=0&id=20eec9c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eec9c4",
  null
  
)

export default component.exports